/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

 document.addEventListener("DOMContentLoaded", function () {
    const currentURL = window.location.href;
    // Check if exact discount URL is visited
    if (currentURL === "https://maineshelledlobster.com/discount/Welcome10") {
      // Redirect to lobster meat collection
      window.location.href = "https://maineshelledlobster.com/collections/lobster-meat";
    }
  });

// Flare can hide an ineligible date picker after locking the product form.
// Its guard observes form changes, but not visibility changes on the picker.
// Notify that guard so Flare restores its own saved state (including sold out).
(function () {
  function initFlareProductGuard() {
    var picker = document.getElementById('flare-date-picker-block');
    var forms = document.querySelectorAll('form.product-form--single[action*="/cart/add"]');
    if (!picker || !forms.length) return;
    var scheduled = false;
    function refreshHiddenPickerGuard() {
      scheduled = false;
      if (picker.style.display !== 'none' && picker.dataset.flarePickerIneligible !== 'true') return;
      forms.forEach(function (form) {
        form.querySelectorAll('button[type="submit"], [name="add"], input[type="submit"]').forEach(function (button) {
          // Only notify for Flare's exact lock; never enable a button ourselves.
          if ((button.disabled || button.getAttribute('aria-disabled') === 'true') &&
              button.getAttribute('tabindex') === '-1' &&
              button.style.opacity === '0.5' &&
              button.style.cursor === 'not-allowed' &&
              button.style.getPropertyPriority('cursor') === 'important') {
            button.setAttribute('class', button.getAttribute('class') || '');
          }
        });
      });
    }
    function scheduleRefresh() {
      if (!scheduled) {
        scheduled = true;
        setTimeout(refreshHiddenPickerGuard, 0);
      }
    }
    var observer = new MutationObserver(scheduleRefresh);
    observer.observe(picker, { attributes: true, attributeFilter: ['style', 'data-flare-picker-ineligible'] });
    forms.forEach(function (form) {
      observer.observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'tabindex', 'style'] });
    });
    scheduleRefresh();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlareProductGuard, { once: true });
  } else {
    initFlareProductGuard();
  }
})();
